module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-native-web/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-amplitude-analytics/gatsby-browser.js'),
      options: {"plugins":[],"respectDNT":true,"eventTypes":{"pageView":"Route.Update"},"amplitudeConfig":{"trackingOptions":{"city":false,"country":true,"carrier":false,"device_manufacturer":false,"device_model":false,"dma":false,"ip_address":false,"language":true,"os_name":true,"os_version":true,"platform":true,"region":false,"version_name":true}},"environments":["production"]},
    },{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
